import React from "react";
import { ageShort } from "../history/historyUtils";

const text = (value) => String(value || "").replaceAll("_", " ");
const title = (value) => text(value).toLowerCase().replace(/\b\w/g, (letter) => letter.toUpperCase());

function metric(value, suffix = "") {
  return Number.isFinite(value) ? `${value}${suffix}` : "Not available";
}

function number(value) {
  return Number.isFinite(value) ? new Intl.NumberFormat("en-US", { maximumFractionDigits: 8 }).format(value) : "Not available";
}

function when(value) {
  if (!Number.isFinite(value)) return "Not available";
  return new Date(value).toLocaleString();
}

function epochSeconds(value) {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return null;
  return Math.floor(numeric > 10_000_000_000 ? numeric / 1000 : numeric);
}

export default function AssessmentTile({ assessment, coinData, onOpen, compact = false }) {
  const event = assessment?.event || {};
  const currentPrice = Number(coinData?.price);
  const eventPrice = Number(event.price);
  const assessedAge = ageShort(epochSeconds(assessment?.assessedAt));
  return (
    <article className={`assessmentTile assessmentTile${title(assessment.side)}${compact ? " assessmentTileCompact" : ""}`}>
      <button
        type="button"
        className="assessmentTileOpen"
        data-assessment-id={assessment.id}
        aria-label={`Open assessment ${assessment.symbol} ${assessment.side}`}
        onClick={() => onOpen(assessment.id)}
      >
        <span className="assessmentTileHeading">
          <strong>{assessment.symbol}</strong>
          <span className={`assessmentSide assessmentSide${title(assessment.side)}`}>{assessment.side}</span>
          <span>{text(event.timeframe || "TF unavailable")}</span>
        </span>
        <span className="assessmentEventName">{event.name || "Recorded assessment"}</span>
        <span className="assessmentTileBadges">
          <span>{title(assessment.type)}</span>
          <span>{title(assessment.provider)}</span>
          <span>{title(assessment.outcome)}</span>
          {!compact && <span>{title(assessment.trigger)}</span>}
          {!compact && assessment.sentimentImpact && <span>Global {title(assessment.sentimentImpact)}</span>}
        </span>
        <span className="assessmentMetrics">
          <span>{Number.isFinite(assessment.adjustedConfidence) ? "Adjusted confidence" : "Confidence"} {metric(assessment.confidence, "%")}</span>
          {!compact && Number.isFinite(assessment.technicalConfidence)
            && <span>Technical {metric(assessment.technicalConfidence, "%")}</span>}
          {!compact && <span>Score {metric(assessment.score)}</span>}
          {!compact && <span>Timing {assessment.timing ? title(assessment.timing) : "Not available"}</span>}
        </span>
        {!compact && <span className="assessmentPrices">
          <span>Event price {number(eventPrice)}</span>
          <span>Current price {number(currentPrice)}</span>
          {Number.isFinite(Number(coinData?._24H)) && <span>24h {Number(coinData._24H).toFixed(2)}%</span>}
        </span>}
        <span className="assessmentTimes">
          <span>{compact && assessedAge ? `${assessedAge} ago` : `Assessed ${when(assessment.assessedAt)}`}</span>
          {!compact && <span>Event {when(event.occurredAt)}</span>}
        </span>
      </button>
    </article>
  );
}
